<script setup lang="ts">
import { $getCampaignOptions } from '@/api/campaigns'

interface IProps {
  modelValue?: any,
  label?: string,
  selectOptions?: any[] | null,
  /**
   * Optional array of category1 IDs that should be disabled for selection.
   * If null or undefined, no event groups will be disabled.
   */
  disabledCategories1?: number[] | null,
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: null,
  label: 'Category 1',
  selectOptions: null,
  disabledCategories1: null,
})

interface CustomEvents {
  'update:modelValue': (newValue: any) => void;
}

const emit = defineEmits<CustomEvents>()

interface Category1 {
  value: number
  display_name: string
}

const categories1 = ref<Category1[]>([])
const categories1Loading = ref<boolean>(false)

const category1Options = computed(() => {
  if (props.selectOptions) {
    return props.selectOptions
  } else {
    return categories1.value
  }
})

const getCategories1 = async () => {
  categories1Loading.value = true
  try {
    const res = await $getCampaignOptions()
    categories1.value = res.data.actions.POST.category_1.choices
  } catch (e) {
    console.log(e)
  } finally {
    categories1Loading.value = false
  }
}

const onFocusCategory1Select = async () => {
  if (!categories1.value.length && !props.selectOptions) {
    await getCategories1()
  }
}
</script>

<template>
  <VAutocomplete
    :model-value="modelValue"
    :items="[...category1Options]"
    return-object
    item-title="display_name"
    item-value="value"
    :label="label"
    density="compact"
    multiple
    clearable
    @update:modelValue="newValue => $emit('update:modelValue', newValue)"
    @update:focused="onFocusCategory1Select"
  >
    <template
      v-if="disabledCategories1"
      #item="{ item, index, props }"
    >
      <VListItem
        v-bind="props"
        :disabled="!!disabledCategories1 ? disabledCategories1.includes(item?.value) : false"
      />
    </template>
    <template #selection="{ item, index }">
      <div class="d-flex align-center">
        <v-chip v-if="index < 1">
          <span>{{ item.title }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="text-grey text-caption align-self-center"
        >
          (+{{ modelValue?.length - 1 }} others)
        </span>
      </div>
    </template>
    <template #no-data>
      <div
        v-if="!!categories1Loading"
        class="d-flex justify-center align-center"
      >
        Loading...
        <VProgressCircular
          class="margin-left-5"
          size="22"
          indeterminate
          color="white"
        />
      </div>
      <div
        v-else
        class="d-flex justify-center align-center"
      >
        Categories not found
      </div>
    </template>
  </VAutocomplete>
</template>

<style lang="scss">

</style>
